import { createRoute, redirect } from '@tanstack/react-router';
import { rotaRaiz } from './raiz';
import { garantirSessao } from '../api';

/**
 * A árvore de arquivos virou o explorador do workspace, com abas no centro.
 *
 * Manter duas telas que abrem o mesmo arquivo custaria manter as duas para
 * sempre — e ainda faria a pessoa escolher entre elas sem motivo. O endereço
 * antigo leva ao explorador já apontado para a máquina certa.
 */
export const rotaArquivos = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/maquinas/$id/arquivos',
  beforeLoad: async ({ params }) => {
    if (!(await garantirSessao())) throw redirect({ to: '/entrar' });
    throw redirect({ to: '/', search: { m: params.id, lado: 'explorador' } });
  },
});
